
import React, { useEffect, useState } from 'react';
import { View } from 'react-native';

import { Card, Row, Spacer } from '@components/1-atoms';
import Text from '@components/1-atoms/Text';
import ListItem from '@components/2-molecules/ListItem';

import { Modal } from '@components/1-atoms';

import MenuIcon from '@assets/icons/menu-light';

import InvisibileIcon from '@assets/icons/invisible';
import VisibileIcon from '@assets/icons/visible';

import useTheme from '@lib/theme';



import { NavigationProp } from '@react-navigation/native';

import { BarChart, HorizontalStackedBarChart, LineChart } from '@components/2-molecules';

import IconButton from '@components/2-molecules/Buttons/IconButton';

import { AccordionItem } from '@/components/2-molecules';

import { CounterUp } from '@/components/1-atoms';
import { ChartAccountDataProps } from '@/interfaces/chart.interface';
import * as utils from '@lib/utils';
import ListChartAccount from '../../Lists/ListChartAccount';
import TransactionList from '../../Lists/ListTransaction';


const theme = useTheme();

type Props = {
  currency: string;
  data: Array<ChartAccountDataProps>;
  navigation: NavigationProp<any>;
};

const BankChart: React.FC<Props> = ({ /* navigation, */ currency, data }) => {

  const [isBalanceVisible, setBalanceVisibility] = useState(true);

  // Selected account or group of account chart data (from hook)
  const [selectedAccountChartData, setSelectedAccountChartData] = useState<ChartAccountDataProps | null>(null);

  const availableBalance = selectedAccountChartData?.availableBalance;
  const lastTransactions = selectedAccountChartData?.lastTransactions;

  const syncedAt = selectedAccountChartData?.syncedAt || new Date();

  // The widget modal
  const [isWidgetModalVisible, setWidgetModalVisiblility] = useState(false);
  const openWidgetModal = () => setWidgetModalVisiblility(true);
  const closeWidgetModal = () => setWidgetModalVisiblility(false);

  // Transaction modal
  const [isTransactionModalVisible, setTransactionModalVisiblility] = useState(false);
  const openTransactionModal = () => setTransactionModalVisiblility(true);
  const closeTransactionModal = () => setTransactionModalVisiblility(false);

  // Update the account chart data to display
  const updateAccount = (accountChart: any) => {
    closeWidgetModal();
    setSelectedAccountChartData(accountChart);
  };

  // Selected the first account chart data (from hook) when it updates
  useEffect(() => {
    // Select the first account data by default
    const accountChart = (data?.length > 0) ? data[0] : null;
    setSelectedAccountChartData(accountChart);
  }, [data]);

  return (
    <>
      <Card
        themed={true}
        title={`${selectedAccountChartData?.name}`}
        subtitle={`${selectedAccountChartData?.description}`}
        icon={<MenuIcon />}
        onAction={openWidgetModal}
      >

        {availableBalance ?
          <View>

            <Row justification="flex-end">
              {/* Visibility button */}
              <IconButton
                icon={isBalanceVisible ? <InvisibileIcon /> : <VisibileIcon />}
                onPress={() => setBalanceVisibility(!isBalanceVisible)} />

              { /* Balance amount */}
              <CounterUp hidden={!isBalanceVisible} xlarge bold currency={currency}>{availableBalance}</CounterUp>
            </Row>
            <Spacer h={1} />

            <Row>
              <Text xsmall align='right'>
                Available balance as of {utils.formatDate(syncedAt)} <Text xsmall>, and last synchronized {utils.dateDistance(new Date(syncedAt), new Date())}</Text>
              </Text>
            </Row>

          </View>
          : null
        }
        <Spacer h={3} />



        {/* Horizontal stacked bar chart */}
        <AccordionItem title={"CATEGORY BREAKDOWN"}>
          <Spacer h={1} />
          <HorizontalStackedBarChart
            data={selectedAccountChartData?.chart || []}
          />
        </AccordionItem>
        <Spacer h={1.3} />

        {/* Bar chart data that show cash in and out */}
        <AccordionItem title={"EARNING & SPENDING"}>
          <Spacer h={1} />
          <BarChart
            data={selectedAccountChartData?.chart || []}
            height={130}
            noOfSections={2}
            rulesType="dashed"
          // onPressLabel={(pt) => Alert.alert("Earning Metrics Info", `Period: ${pt.label}\nCash In: $${pt.cashIn}`)}
          />
        </AccordionItem>
        <Spacer h={1.3} />

        <AccordionItem title={"BALANCE HISTORY"}>
          <Spacer h={1} />
          <LineChart
            data={selectedAccountChartData?.chart || []}
            height={130}
            curved={false}
            noOfSections={2}
            rulesType="dashed"
          // onPressLabel={(pt) => Alert.alert("Balance History Info", `Label: ${pt.label}\nValue: $${pt.value}`)}
          />
        </AccordionItem>

        <Spacer h={3} />

        {/* Button to list / view transactions */}
        <View>
          <ListItem inset onPress={openTransactionModal}>
            <Text bold color={theme.pallete.accentColor}>View transactions</Text>
          </ListItem>
        </View>
      </Card>

      {/* A modal that let the user toggle among bank account charts */}
      <Modal visible={isWidgetModalVisible} title={"Select an account"} onClose={closeWidgetModal}>
        <ListChartAccount defaultValue={selectedAccountChartData} data={data} onPress={updateAccount} />
      </Modal>

      {/* A modal that list the transactions */}
      <Modal visible={isTransactionModalVisible} title={"Recent transactions"} onClose={closeTransactionModal}>
        <TransactionList data={lastTransactions || []} currency={currency} />
      </Modal>
    </>
  );
};


export default BankChart;